function setOverlayHeight(customElement, property) {
    customElement.style.setProperty(property, `${window.innerHeight}px`);
}

export {
    setOverlayHeight
}
